import { Fragment } from "react";
import MenuLink from "@core/components/link/MenuLink";
import { useCnbConfig } from "@core/hooks/useCnbConfig";
import { cn } from "@core/utils/domUtil";

export default function LnbPc() {
  const { activeIndex, activeMenuData } = useCnbConfig() ?? {};

  return (
    <section className="header-xl:block mr-[70px] hidden w-[170px] flex-shrink-0">
      {/** depth1 */}
      <div className={cn("mt-[71px] mb-[30px] border-b-1 border-gray-200 pb-[10px]")}>
        <h1 className={cn("text-[28px] font-medium text-gray-800")}>{activeMenuData?.name}</h1>
      </div>
      {/** depth2 */}
      {activeMenuData?.children?.map((item, depth2Idx) => (
        <Fragment key={item.name}>
          <div className={cn("py-[5px] pl-[4px]")}>
            <h2>
              <MenuLink url={item.url} name={item.name} className={cn("text-lg font-bold text-gray-800", depth2Idx === activeIndex[1] && "text-point-600")} />
            </h2>
          </div>
          {/** depth3 */}
          {Array.isArray(item.children) ? (
            <div className={cn("mt-[8px] mb-[15px] ml-[6px] flex flex-col border-l-1 border-gray-200")}>
              {item?.children?.map((child, depth3Idx) => (
                <div key={child.name} className={cn("relative", "before:bg-point-600 rounded-lg before:absolute before:top-0 before:left-[-1px] before:hidden before:h-full before:w-[2px]", depth2Idx === activeIndex[1] && depth3Idx === activeIndex[2] && "before:block")}>
                  <h3>
                    <MenuLink url={child.url} name={child.name} className={cn("text-md ml-[6px] block rounded-lg py-[6px] pl-[4px] font-medium hover:bg-gray-50", depth2Idx === activeIndex[1] && depth3Idx === activeIndex[2] && "text-point-600")} />
                  </h3>
                </div>
              ))}
            </div>
          ) : (
            <Fragment />
          )}
        </Fragment>
      ))}
    </section>
  );
}
